export default {
    data() {
        return {
            suppressSiteList: [
                'eBay',
                'Discogs',
                'Amazon',
            ]
        }
    }
}